module.exports = __webpack_public_path__ + "img/de_Ecran 5.6efc2a16.png";